import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const STATUS = { subscribed: "Iscritto", unsubscribed: "Disiscritto", paused: "In pausa" };

export function DuplicateContactNotice({ existing, canForce, onForce, onOpenExisting }) {
  const [reason, setReason] = useState("");
  return (
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 space-y-2" data-testid="duplicate-notice">
      <p className="text-sm text-amber-200 font-medium flex items-center gap-2"><AlertTriangle className="h-4 w-4" /> Numero già presente in rubrica</p>
      <p className="text-xs text-slate-300" data-testid="duplicate-existing">
        <b>{[existing.name, existing.surname].filter(Boolean).join(" ") || "—"}</b> · {existing.phone} · {STATUS[existing.status] || existing.status}
        {existing.created_at ? ` · creato il ${existing.created_at.slice(0, 10)}` : ""}
      </p>
      <div className="flex flex-wrap gap-2">
        {onOpenExisting && <Button type="button" size="sm" variant="outline" className="border-[#1F2937] text-slate-200" onClick={() => onOpenExisting(existing)} data-testid="duplicate-open-existing">Apri il contatto esistente</Button>}
      </div>
      {canForce ? (
        <div className="space-y-2 pt-1">
          <p className="text-[11px] text-slate-400">Forzatura (Admin): crea comunque un secondo record, tracciato nel log operazioni. Un consenso revocato sul contatto esistente non viene mai ripristinato.</p>
          <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivazione obbligatoria" className="bg-[#0A0E17] border-[#1F2937] h-9" data-testid="duplicate-force-reason" />
          <Button type="button" size="sm" disabled={!reason.trim()} onClick={() => onForce(reason.trim())} className="bg-amber-500 hover:bg-amber-600 text-[#0A0E17] font-semibold" data-testid="duplicate-force-button">Crea comunque (forza duplicato)</Button>
        </div>
      ) : <p className="text-[11px] text-slate-500">Solo un Admin azienda o Super Admin può forzare la creazione di un duplicato.</p>}
    </div>
  );
}
